import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';

const mapStateToPropsFunction = (appLabel, formValueLabel, initialState) => {
  return (state) => {
    // Get state for this class.
    const props = Object.keys(initialState).filter(e => e != 'formData');
    const ret = Object.assign(...props.map(prop => ({[prop]: state[appLabel][prop]})));

    // Map form state.
    const selector = formValueSelector(formValueLabel);
    const form = Object.assign({}, ...(Object.keys(state[appLabel].formData).map(key => ({[key]: selector(state, key)}))));
    Object.assign(ret, {[formValueLabel]: form});

    return ret;
  };
};

const mapDispatchToPropsFunction = (actions) => {
  return (dispatch) => {
    const entries = Object.entries(actions);
    if (entries.length === 0) {
      return {};
    }

    const dispatchToProp = entries.map(([key, value]) => ({[key]: (...args) => dispatch(value(...args))}));
    return Object.assign(...dispatchToProp);
  };
};

const wrappedApp = (mapStateToProps, mapDispatchToProps, appLabel, formValueLabel, App) => {
  let _App = connect(mapStateToProps, mapDispatchToProps)(App);
  _App = reduxForm({
    form: formValueLabel,
  })(_App);

  // Pull initial values
  _App = connect(
    state => ({
      initialValues: state[appLabel].formData
    }),
  )(_App);

  return _App;
};

export const connectAll = (appLabel, formValueLabel, initialState, actions) => {
  const mapStateToProps = mapStateToPropsFunction(appLabel, formValueLabel, initialState);
  const mapDispatchToProps = mapDispatchToPropsFunction(actions);
  return (App) => wrappedApp(mapStateToProps, mapDispatchToProps, appLabel, formValueLabel, App);
};
